exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ButtonLabel___3a0f3 {\n  padding-left: 1.5rem;\n  margin-left: -1rem;\n  user-select: none;\n  flex: 1 0 auto;\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"ButtonLabel": "ButtonLabel___3a0f3"
};